import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Al completar el pago recibís un email con acceso inmediato a todos los PDFs. En menos de 5 minutos tenés todo descargado y listo para usar.'
  }, {
    q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
    a: 'Sirve para los dos. Si sos nuevo: tenés todo estructurado para no improvisar desde el día 1. Si tenés experiencia: encontrás el sistema que te faltaba para profesionalizar lo que ya sabés hacer.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus estratégicos están incluidos tanto en el Pack Profesional como en el Megapack Élite. Los Ebooks Élite son el único contenido exclusivo del Megapack.'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'La mayoría de los materiales son ejercicios sueltos sin progresión. Fútbol 360 es el único sistema del mercado argentino que planifica las 52 semanas del año, para las 5 categorías de edad, con sesiones completas listas para usar sin adaptar nada.'
  }, {
    q: '¿Sirve para grupos con edades o niveles mezclados?',
    a: 'Sí. Cada tomo incluye variantes FÁCIL y DIFÍCIL en cada sesión, diseñadas específicamente para grupos heterogéneos. El Bonus NiveLómetro 360 te ayuda a detectar el nivel real del grupo en 20 minutos.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si abrís el material y no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya planifico bien mis sesiones?',
    a: 'Si ya planificás bien las sesiones, el Megapack Élite te resuelve lo que ningún ejercicio puede resolver: la relación con los padres, la autoridad frente al club y el arsenal creativo para que el grupo nunca se aburra. Son las dos herramientas que separan a un buen profe de un DT irremplazable.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago. El acceso es inmediato en todos los casos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-f360-bg" data-id="element-105">
      <div className="max-w-[800px] mx-auto" data-id="element-106">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-extrabold text-center text-gray-900 mb-12" data-id="element-107">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-108">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04
        }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-109">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-110">
                <span className="font-bold text-gray-900 pr-4" data-id="element-111">❓ {faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-f360-green transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-112" />
              </button>
              <AnimatePresence initial={false} data-id="element-113">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-114">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-115">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}